import { useEffect, useState } from "react";
import { Modal, Collapse } from "antd";
import { TitleIndex } from "../styles";
import FormCadastroInicial from "./FormCadastroInicial";
import FormValidacaoProprietario from "./FormValidacaoProprietario";
import FormConfiguracaoPropriedade from "./FormConfiguracaoPropriedade";
import { Cota } from "../../../interfaces/Cota";
import FormAnuncioPropriedade from "./FormAnuncioPropriedade";
import { Usuario } from "../../../interfaces/Usuario";
import { Endereco } from "../../../interfaces/Endereco";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { Empreendimento } from "../../../interfaces/Empreendimento";
import { Apartamento } from "../../../interfaces/Apartamento";
import { useCadastrarPropriedade } from "../hooks/useCadastrarPropriedade";
import { useMessage } from "../../../uteis/mensagens/useMessage";

interface ModalAdicionarPropriedadeProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  usuarioId: number;
  cotaUsuarioId: number;
}

export default function ModalAdicionarPropriedade({
  isModalOpen,
  handleFechar,
  usuarioId,
  cotaUsuarioId,
}: ModalAdicionarPropriedadeProps) {
  // Estado inicial de Cadastro Inicial Empreendimento
  const [empreeendimento, setEmpreendimento] = useState<Empreendimento>({});

  // Estado inicial de Cadastro Inicial Apartamento
  const [apartamento, setApartamento] = useState<Apartamento>({});

  // Estado inicial de Cadastro Inicial MaisInfo
  const [maisInfo, setMaisInfo] = useState<Partial<CotaUsuario>>({});

  // Estado inicial  cadastro Proprietario
  const [cadastroProprietario, setCadastroProprietario] = useState<Usuario>({});

  // Estado inicial  cadastro endereço Proprietario
  const [enderecoProprietario, setEnderecoProprietario] = useState<Endereco>(
    {}
  );

  // Estado inicial  cadastro Representante
  const [cadastroRepresentante, setCadastroRepresentante] = useState<Usuario>(
    {}
  );

  // Estado inicial  Atualizar endereço Representante
  const [enderecoRepresentante, setEnderecoRepresentante] = useState<Endereco>(
    {}
  );

  // Estado inicial  Atualizar endereço Representante
  const [dadosCota, setDadosCota] = useState<Cota>({});

  // Estado inicial  Atualizar endereço Representante
  const [dadosCotaUsuario, setDadosCotaUsuario] = useState<CotaUsuario>({} as CotaUsuario);

  const [empreendimentoSistema, setEmpreendimentoSistema] =
    useState<boolean>(false);

  // UseState necessário para verificar se é necessário Vincular a propriedade a um representante
  const [representante, setRepresentante] = useState<boolean>(false);

  const [cotas, setCotas] = useState<Cota[]>([]);

  // Exibe a Mensagem de  Erro
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  

  const {
    handleCadastrarTodos,
    isLoading,
    error,
    success,
    resetError,
    resetSuccess,
  } = useCadastrarPropriedade();

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);
      setTimeout(() => {
        resetSuccess(); // ✅
        window.location.reload();
      }, 3000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);
      setTimeout(() => {
        resetError(); // ✅
      }, 3000);
    }
  }, [
    error,
    success,
    resetError,
    resetSuccess,
    successDisplayed,
    errorDisplayed,
  ]);

  return (
    <Modal
      open={isModalOpen}
      width={800}
      onCancel={handleFechar}
      cancelText="Cancelar"
      okText="Cadastrar"
      onOk={() => {
        handleCadastrarTodos(
          {
            empreendimento: empreeendimento,
            apartamento: apartamento,
            cota: dadosCota,
            cotaUsuario: dadosCotaUsuario,
            maisInfo: {
              ...maisInfo,
              checked: maisInfo.checked ?? 0, // Ensure 'checked' is a number
            },
            proprietario: cadastroProprietario,
            enderecoProprietario: enderecoProprietario,
            representante: cadastroRepresentante,
            enderecoRepresentante: enderecoRepresentante,
          },
          empreendimentoSistema,
          representante,
          usuarioId
        );
      }}
      confirmLoading={isLoading}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        },
      }}
    >
      <TitleIndex>Adicionar Nova Propriedade</TitleIndex>
      {contextHolder}
      <Collapse
        accordion
        items={[
          {
            key: "1",
            label: "Cadastro Inicial",
            children: (
              <FormCadastroInicial
                setEmpreendimento={setEmpreendimento}
                setApartamento={setApartamento}
                setMaisInfo={setMaisInfo}
                setEmpreendimentoSistema={setEmpreendimentoSistema}
                setCotas={setCotas}
              />
            ),
          },
          {
            key: "2",
            label: "Validação de Proprietário",
            children: (
              <FormValidacaoProprietario
                cotaUsuarioId={cotaUsuarioId}
                setCadastroProprietario={setCadastroProprietario}
                setEnderecoProprietario={setEnderecoProprietario}
                setCadastroRepresentante={setCadastroRepresentante}
                setEnderecoRepresentante={setEnderecoRepresentante}
                setRepresentante={setRepresentante}
                representante={representante}
              />
            ),
          },
          {
            key: "3",
            label: "Configuração de Propriedade",
            children: (
              <FormConfiguracaoPropriedade
                empreendimentoSistema={empreendimentoSistema}
                cotas={cotas}
                setDadosCota={setDadosCota}
                setDadosCotaUsuario={setDadosCotaUsuario}
              />
            ),
          },
          {
            key: "4",
            label: "Anúncio de Venda",
            children: (
              <FormAnuncioPropriedade
                dadosCotaUsuario={dadosCotaUsuario}
                setDadosCotaUsuario={setDadosCotaUsuario}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
}
